import { gettext } from '@eventbrite/i18n';
import { Typography } from '@eventbrite/marmalade';
import { TimeSlotList, TimeSlotProps } from '@eventbrite/timed-entry';
import React, { FC } from 'react';
import { TimeSlotLoadingSkeleton } from '../TimeSlotLoadingSkeleton/TimeSlotLoadingSkeleton';
import { getDurationString, getFormattedTime } from '../utils';
import styles from './TimeSlotSelector.module.scss';

type TimeSessionProps = {
    sessions: Array<TimeSlotProps>;
    duration: string;
    onSessionClick: (sessionId: string, sessionLabel: string) => void;
    timezone: string;
    locale: string;
    selectedTime: string;
    loading?: boolean;
};

const TimeSlotSelector: FC<TimeSessionProps> = ({
    sessions,
    onSessionClick,
    loading = false,
    duration,
    timezone,
    locale,
    selectedTime,
}) => {
    function handleSessionClick(timeSlot: TimeSlotProps) {
        onSessionClick(
            timeSlot.id,
            getFormattedTime(timeSlot.startDatetime, locale, timezone),
        );
    }
    return (
        <>
            {loading ? (
                <TimeSlotLoadingSkeleton />
            ) : (
                <Typography
                    variant="body-md-bold"
                    color="neutral-800"
                    className={styles.durationText}
                    data-testid="duration-text"
                >
                    {gettext('Duration: %(duration)s', {
                        duration: getDurationString(Number(duration)),
                    }).toString()}
                </Typography>
            )}
            <TimeSlotList
                timeSlots={sessions}
                handleTimeClick={handleSessionClick}
                isLoading={loading}
                selectedTime={selectedTime}
            />
        </>
    );
};

export default TimeSlotSelector;
